import Link from 'next/link'

import { getCategories } from '../../../lib/api'

import Navbar from 'components/navbar'
import Layout from 'components/layout'
import Seo from 'components/seo'
import Pagetitle from 'components/pageTitle'
import Footer from 'components/footer'

export default function categories({ categories }) {
  return (
    <>
      <Seo
        title="Les catégories du blog"
        description="Découvrez toutes les catégories du blog d'Atelier Milky."
        canonical="/blog/categorie"
      >
        <meta name="robots" content="noindex" />
      </Seo>
      <Navbar />
      <main className="mt-12 min-h-screen md:mt-24">
        <Layout>
          <Pagetitle>Les catégories</Pagetitle>

          <div className="grid gap-8 grid-cols-1 mt-8 md:grid-cols-3">
            {categories.nodes
              .sort((a, b) => b.count - a.count)
              .map((thisCategorie) => (
                <Link key={thisCategorie.id} href={`/blog/categorie/${thisCategorie.slug}`}>
                  <a className="flex items-center justify-center w-full h-24 border hover:border-2 border-black focus:outline-none hover:shadow-lg duration-75 focus:ring-gray-700 focus:ring-offset-2 focus:ring-2">
                    <div className="font-serif text-xl font-bold">{thisCategorie.name}</div>
                  </a>
                </Link>
              ))}
          </div>
        </Layout>
      </main>
      <div className="mt-32">
        <Footer />
      </div>
    </>
  )
}

export async function getStaticProps() {
  const categories = await getCategories()
  return {
    props: { categories },
    revalidate: 1800 // 30 min
  }
}
